export default __webpack_public_path__ + "static/media/sentiment_normal.88688696.svg";